import Model from '@/models/Model'

export default class extends Model {
    resource() {
        return 'massive_asset_discount'
    }
}